export default [
  {
    path: 'student-list-dt',
    name: 'student-list-dt',
    component: () => import('@/views/pages/student-list/StudentListDt.vue'),
    meta: {
      pageTitle: 'Doctoral And Trainee Researchers',
      breadcrumb: [
        {
          text: 'Searchers List',
        },
      ],
      resource: 'StudentList',
      scholarship: 100,
    },
  },
  {
    path: 'student-list-i',
    name: 'student-list-i',
    component: () => import('@/views/pages/student-list/StudentListI.vue'),
    meta: {
      pageTitle: 'Independent students',
      breadcrumb: [
        {
          text: 'Searchers List',
        },
      ],
      resource: 'StudentList',
      scholarship: 200,
    },
  },
  {
    path: 'student-list-f',
    name: 'student-list-f',
    component: () => import('@/views/pages/student-list/StudentListF.vue'),
    meta: {
      pageTitle: 'Scholarship Foreign',
      breadcrumb: [
        {
          text: 'Searchers List',
        },
      ],
      resource: 'StudentList',
      scholarship: 300,
    },
  },
  {
    path: 'student-list-o',
    name: 'student-list-o',
    component: () => import('@/views/pages/student-list/StudentListO.vue'),
    meta: {
      pageTitle: 'Scholarship Organization',
      breadcrumb: [
        {
          text: 'Searchers List',
        },
      ],
      resource: 'StudentList',
      scholarship: 400,
    },
  },
]
